import AnalyzerService from "@/services/AnalyzerService";

const state = {
  differenceInDestCountriesConfig: [],
  summaries: [],
  missingCorridors: [],
  deviatedEndRateFromMarket: [],
  existingManualRates: [],
}

const mutations = {
  setDifferenceInDestCountriesConfig(state, value) {
    state.differenceInDestCountriesConfig = [...value];
  },
  setSummaries(state, value) {
    state.summaries = [...value]
  },
  setMissingCorridors(state, value) {
    state.missingCorridors = [...value]
  },
  setDeviatedEndRateFromMarket(state, value) {
    state.deviatedEndRateFromMarket = [...value]
  },
  setExistingManualRates(state, value) {
    state.existingManualRates = [...value]
  },
}

const getters = {
  differenceInDestCountriesConfig: state => state.differenceInDestCountriesConfig,
  summaries: state => state.summaries,
  missingCorridors: state => state.missingCorridors,
  deviatedEndRateFromMarket: state => state.deviatedEndRateFromMarket,
  existingManualRates: state => state.existingManualRates,
}

const actions = {
  async getDifferenceInDestCountriesConfig({commit}) {
    try {
      const {list} = await AnalyzerService.getDifferenceInDestCountriesConfig();
      commit("setDifferenceInDestCountriesConfig", list);
    } catch (error) {
      commit("setDifferenceInDestCountriesConfig", []);
    }
  },
  async getSummaries({commit}) {
    try {
      const data = await AnalyzerService.getSummaries();
      commit("setSummaries", data);
    } catch (error) {
      commit("setSummaries", []);
    }
  },
  async getMissingCorridors({commit}) {
    try {
      const data = await AnalyzerService.getMissingCorridors();
      commit("setMissingCorridors", data);
    } catch (error) {
      commit("setMissingCorridors", []);
    }
  },
  async getDeviatedEndRateFromMarket({commit}) {
    try {
      const data = await AnalyzerService.getDeviatedEndRateFromMarket();
      commit("setDeviatedEndRateFromMarket", data);
    } catch (error) {
      commit("setDeviatedEndRateFromMarket", []);
    }
  },
  async getExistingManualRates({commit}) {
    try {
      const data = await AnalyzerService.getExistingManualRates();
      commit("setExistingManualRates", data.map(item => {
        return {
          records: item.manualRates,
          tenantFriendlyName: item.tenantFriendlyName,
        }
      }));
    } catch (error) {
      commit("setExistingManualRates", []);
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};